import type { IStore } from '@rbi-ctg/store';
import { CartPaymentCardType } from 'generated/rbi-graphql';
import { ServiceMode } from 'state/service-mode';
import { getName } from 'utils/attributes';

import { clearUserContext, getUserContext, updateUserContext } from './client';
export {
  waitForClientInitialization,
  LdProvider,
  getFlagSync,
  getAllFlagsSync,
  updateUserContext,
  useFlag,
  useAllFlags,
} from './client';

export function login(userLogin: {
  cognitoId?: string;
  details: { name?: string; email: string };
}) {
  return updateUserContext({
    ...getName({ name: userLogin.details?.name }, { firstName: '', lastName: '' }),
    key: userLogin.cognitoId,
    name: userLogin.details?.name,
    email: userLogin.details?.email,
    anonymous: false,
  });
}

export function logout() {
  return clearUserContext();
}

export async function isUserAuthenticated() {
  const userContext = await getUserContext();
  return Boolean(userContext && !userContext.anonymous && userContext.email);
}

// previously named updateCheckoutSelections
export function updateCheckoutPaymentType(paymentType?: CartPaymentCardType) {
  return updateUserContext({
    paymentType: paymentType ?? '',
  });
}

export function updateUserStore(
  store: null | Pick<
    IStore,
    'number' | 'physicalAddress' | 'franchiseGroupName' | 'pos' | 'vatNumber'
  >
) {
  return updateUserContext({
    // store info is in custom object due to previous implementation
    // existing flags refer to custom
    custom: {
      storeNumber: store?.number ?? '',
      storeCity: store?.physicalAddress?.city ?? '',
      storeCountry: store?.physicalAddress?.country ?? '',
      storePostalCode: store?.physicalAddress?.postalCode ?? '',
      storeStateProvince: store?.physicalAddress?.stateProvince ?? '',
      storeStateProvinceShort: store?.physicalAddress?.stateProvinceShort ?? '',
      storeFranchiseGroupName: store?.franchiseGroupName ?? '',
      storePosVendor: store?.pos?.vendor ?? '',
      storePosVersion: store?.pos?.version ?? '',
      storeVatNumber: store?.vatNumber ?? '',
    },
  });
}

export function updateServiceMode(serviceMode: ServiceMode | null) {
  return updateUserContext({
    custom: {
      // serviceMode is in custom object due to previous implementation
      // existing flags refer to custom
      serviceMode,
    },
  });
}

export const updateUserDeviceId = (deviceId: string) => {
  return updateUserContext({
    device_id: deviceId,
  });
};
